
import { ImpactAssessmentT6ListDto } from './impact-assessmentT6-list';

export class UpdateImpactAssessmentT6Model {
    impactAssessment: ImpactAssessmentT6ListDto;
    isAssessmentTeam: boolean;
    isAssessor: boolean;
    isAssessorDel: boolean;
    isAssessmentStatus: boolean;
    isImplementationType: boolean;
    isImpactRating: boolean;
    isReviewerTeam: boolean;
    isReviewer: boolean;
    isReviewerDel: boolean;
    isReviewStatus: boolean;
    isImplementationStatus: boolean;
    isImplementationTeam: boolean;
    isImplementationOwner: boolean;
    isOwnerDel: boolean;
    // isSendNotification: boolean;
    isLineOfBusiness:boolean;

    constructor() {
        this.impactAssessment = new ImpactAssessmentT6ListDto();
        this.isAssessmentTeam = false;
        this.isAssessor = false;
        this.isAssessorDel = false;
        this.isAssessmentStatus = false;
        this.isImplementationType = false;
        this.isImpactRating = false;
        this.isReviewerTeam = false;
        this.isReviewer = false;
        this.isReviewerDel = false;
        this.isReviewStatus = false;
        this.isImplementationTeam = false;
        this.isImplementationOwner = false;
        this.isOwnerDel = false;
        this.isImplementationStatus = false;
        // this.isSendNotification = false;
        this.isLineOfBusiness = false;
    }
}
